import { useState } from 'react';

const faqs = [
  {
    q: '妖精视频需要注册才能观看吗？',
    a: '不需要注册或登录。妖精视频所有数字颜色系列内容（包括红桃视频、小蓝视频、黑桃视频、91视频、97视频、久久视频等频道）均为免费在线播放，打开即看。',
  },
  {
    q: '视频播放时会卡顿或需要缓冲吗？',
    a: '我们部署了全球CDN加速网络，确保高清视频即点即播。97视频和黑桃视频的4K片源也经过专门优化，在正常网络环境下几乎无缓冲等待。',
  },
  {
    q: '手机和平板上能正常观看吗？',
    a: '完全支持。妖精视频采用响应式设计，自动适配PC、平板、手机等所有设备。小蓝视频和红桃视频的所有内容都支持移动端全屏播放，横竖屏自由切换。',
  },
  {
    q: '各频道的更新频率是怎样的？',
    a: '数字颜色系列各频道保持高频率更新：91视频风格频道每日更新，红桃视频和黑桃视频连载保持周更节奏，小蓝视频周末批量上新，久久视频不定期推出专题合集。',
  },
  {
    q: '网站有广告或弹窗吗？',
    a: '妖精视频坚持纯净观影体验，全站无弹窗广告、无恶意跳转、无捆绑插件。我们相信好的内容不需要靠骚扰用户来盈利，专注为你提供最佳的数字颜色系列观看环境。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="relative py-14 md:py-20 bg-background-900/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs md:text-sm text-accent-400 font-medium tracking-wider uppercase mb-2">FAQ</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-foreground-50 tracking-wide">常见问题</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">关于妖精视频数字颜色系列平台的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-800/40 border border-background-700/30 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-700/30 transition-colors duration-200"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-200 pr-4">{faq.q}</h3>
                {openIdx === idx ? (
                  <i className="ri-arrow-up-s-line text-foreground-500 text-lg shrink-0 transition-transform duration-300"></i>
                ) : (
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg shrink-0 transition-transform duration-300"></i>
                )}
              </button>
              {openIdx === idx && (
                <div className="px-4 md:px-5 pb-4 md:pb-5 pt-0">
                  <p className="text-sm text-foreground-500 leading-relaxed border-t border-background-700/30 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}